export const sessionActions = {
  LOGIN: "SESSION/LOGIN",
  LOGOUT: "SESSION/LOGOUT",
  ME: "SESSION/ME",
  RESET: "SESSION/RESET",
  UPDATE_ME: "SESSION/UPDATE_ME"
};

export const requestActions = {
  REQUEST: "REQUEST/REQUEST",
  FAILED: "REQUEST/FAILED",
  SUCCESS: "REQUEST/SUCCESS",
  POP_MESSAGE: "REQUEST/POP_MESSAGE"
};

export const imageActions = {
  LIST: "IMAGE/LIST",
  CLEAR_CURRENT: "IMAGE/CLEAR_CURRENT",
  CURRENT: "IMAGE/CURRENT",
  CUD: "IMAGE/CUD"
};

export const fileActions = {
  LIST: "FILE/LIST",
  CLEAR_CURRENT: "FILE/CLEAR_CURRENT",
  CURRENT: "FILE/CURRENT",
  CUD: "FILE/CUD"
};

export const bannerActions = {
  LIST: "BANNER/LIST",
  CLEAR_CURRENT: "BANNER/CLEAR_CURRENT",
  CURRENT: "BANNER/CURRENT",
  CUD: "BANNER/CUD"
};

export const nationActions = {
  LIST: "NATION/LIST",
  CLEAR_CURRENT: "NATION/CLEAR_CURRENT",
  CURRENT: "NATION/CURRENT",
  CUD: "NATION/CUD"
};

export const columnActions = {
  LIST: "COLUMN/LIST",
  CLEAR_CURRENT: "COLUMN/CLEAR_CURRENT",
  CURRENT: "COLUMN/CURRENT",
  CUD: "COLUMN/CUD"
};

export const videoActions = {
  LIST: "VIDEO/LIST",
  CLEAR_CURRENT: "VIDEO/CLEAR_CURRENT",
  CURRENT: "VIDEO/CURRENT",
  CUD: "VIDEO/CUD"
};

export const numberActions = {
  LIST: "NUMBER/LIST",
  CLEAR_CURRENT: "NUMBER/CLEAR_CURRENT",
  CURRENT: "NUMBER/CURRENT",
  CUD: "NUMBER/CUD"
};

export const newActions = {
  LIST: "NEW/LIST",
  CLEAR_CURRENT: "NEW/CLEAR_CURRENT",
  CURRENT: "NEW/CURRENT",
  CUD: "NEW/CUD"
};

export const activityActions = {
  LIST: "ACTIVITY/LIST",
  CLEAR_CURRENT: "ACTIVITY/CLEAR_CURRENT",
  CURRENT: "ACTIVITY/CURRENT",
  CUD: "ACTIVITY/CUD"
};

export const tagActions = {
  LIST: "TAG/LIST",
  CLEAR_CURRENT: "TAG/CLEAR_CURRENT",
  CURRENT: "TAG/CURRENT",
  CUD: "TAG/CUD"
};

export const magazineActions = {
  LIST: "MAGAZINE/LIST",
  CLEAR_CURRENT: "MAGAZINE/CLEAR_CURRENT",
  CURRENT: "MAGAZINE/CURRENT",
  CUD: "MAGAZINE/CUD"
};

export const faqActions = {
  LIST: "FAQ/LIST",
  CLEAR_CURRENT: "FAQ/CLEAR_CURRENT",
  CURRENT: "FAQ/CURRENT",
  CUD: "FAQ/CUD",
  CATEGORY_LIST: "FAQ/CATEGORY/LIST",
  CATEGORY_CLEAR_CURRENT: "FAQ/CATEGORY/CLEAR_CURRENT",
  CATEGORY_CURRENT: "FAQ/CATEGORY/CURRENT",
  CATEGORY_CUD: "FAQ/CATEGORY/CUD",
  SUBCATEGORY_LIST: "FAQ/SUBCATEGORY/LIST",
  SUBCATEGORY_CLEAR_CURRENT: "FAQ/SUBCATEGORY/CLEAR_CURRENT",
  SUBCATEGORY_CURRENT: "FAQ/SUBCATEGORY/CURRENT",
  SUBCATEGORY_CUD: "FAQ/SUBCATEGORY/CUD"
};

export const meetingActions = {
  LIST: "MEETING/LIST",
  CLEAR_CURRENT: "MEETING/CLEAR_CURRENT",
  CURRENT: "MEETING/CURRENT",
  CUD: "MEETING/CUD",
  CATEGORY_LIST: "MEETING/CATEGORY/LIST",
  CATEGORY_CLEAR_CURRENT: "MEETING/CATEGORY/CLEAR_CURRENT",
  CATEGORY_CURRENT: "MEETING/CATEGORY/CURRENT",
  CATEGORY_CUD: "MEETING/CATEGORY/CUD",
  SUBCATEGORY_LIST: "MEETING/SUBCATEGORY/LIST",
  SUBCATEGORY_CLEAR_CURRENT: "MEETING/SUBCATEGORY/CLEAR_CURRENT",
  SUBCATEGORY_CURRENT: "MEETING/SUBCATEGORY/CURRENT",
  SUBCATEGORY_CUD: "MEETING/SUBCATEGORY/CUD",
  CATEGORY_ALL_LIST: "MEETING/CATEGORY/ALL/LIST",
  CATEGORY: "MEETING/CATEGORY",
};

export const eurofileActions = {
  LIST: "EUROFILE/LIST",
  CLEAR_CURRENT: "EUROFILE/CLEAR_CURRENT",
  CURRENT: "EUROFILE/CURRENT",
  CUD: "EUROFILE/CUD",
  CATEGORY_LIST: "EUROFILE/CATEGORY/LIST",
  CATEGORY_CLEAR_CURRENT: "EUROFILE/CATEGORY/CLEAR_CURRENT",
  CATEGORY_CURRENT: "EUROFILE/CATEGORY/CURRENT",
  CATEGORY_CUD: "EUROFILE/CATEGORY/CUD",
  SUBCATEGORY_LIST: "EUROFILE/SUBCATEGORY/LIST",
  SUBCATEGORY_CLEAR_CURRENT: "EUROFILE/SUBCATEGORY/CLEAR_CURRENT",
  SUBCATEGORY_CURRENT: "EUROFILE/SUBCATEGORY/CURRENT",
  SUBCATEGORY_CUD: "EUROFILE/SUBCATEGORY/CUD",
  CATEGORY_ALL_LIST: "EUROFILE/CATEGORY/ALL/LIST"
};
